var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"btn py-4",attrs:{"text":"","x-small":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('v-img',{attrs:{"src":require('@/assets/icon_menu.svg'),"width":"1rem","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }